<ion-card class="content-width" *ngFor="let campaign of campaings$ | async">
  <ion-card-header>
    <ion-card-subtitle>{{ campaign.status}}</ion-card-subtitle>
    <ion-card-title>{{ campaign. title }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    {{ campaign.description}}
    <ion-item lines="none">
      <ion-input fill="solid" mode="md" [ariaReadOnly]="true" type="text" [value]="campaign.url"></ion-input>
    </ion-item>
  </ion-card-content>
</ion-card>

<ion-fab vertical="bottom" horizontal="end" slot="fixed" (click)="createCampaign()">
  <ion-fab-button>
    <ion-icon name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>